import { Commit } from 'vuex'
import api from '@/api';
import { ProductTrackDto } from '@chainsight/networker-backend-axios-sdk';

export function trackManagerPlugin(store) {
    store.dispatch('updateTrackDto');
}

export interface AccessTokenMutationPayload {
    trackDto: ProductTrackDto
}

export interface TrackState {
    trackDto: ProductTrackDto | null
}

const initTrack: TrackState = {
    trackDto: null
}

// getters
const getters = {
}

const actions = {
}

// mutations
const mutations = {
    ['updateTrackDto'](state: TrackState, payload: AccessTokenMutationPayload) {
        state.trackDto = payload.trackDto
    }
}

export default {
    state: initTrack,
    getters,
    actions,
    mutations,
}